<template>
    <div>
        <v-row dense>
            <v-col cols="12" sm="4">
                <v-text-field label="RUC *" v-model="obModal.nroDocumento" outlined dense color="textbox" :rules="_.concat(requeridoRegla,ruc)"/>
            </v-col>
            <v-col cols="12" sm="8">
                <v-text-field label="Razón Social *" v-model="obModal.razonSocial" outlined dense color="textbox"
                    :rules="_.concat(requeridoRegla,letrasRegla)" />
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="4">
                <v-autocomplete label="Provincia *" color="textbox" v-model="obModal.idProvincia"
                    :items="listGeneral.listProvincia" outlined dense @change="onListarCanton"
                    :rules="requeridoRegla" />
            </v-col>
            <v-col cols="12" sm="4">
                <v-autocomplete label="Cantón *" color="textbox" v-model="obModal.idCanton" item-value="idCanton"
                    item-text="canton" :items="listGeneral.listCantonJur" outlined dense :rules="requeridoRegla" />
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field label="Teléfono Celular *" v-model="obModal.celular" outlined dense color="textbox"
                    :rules="requeridoRegla" v-mask="'##########'" />
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="8">
                <v-text-field label="Dirección *" color="textbox" v-model="obModal.direccion" outlined dense
                    :rules="requeridoRegla" />
            </v-col>
            <v-col cols="12" sm="4">
                <v-text-field label="Teléfono PBX *" v-model="obModal.telefonoPbx" outlined dense color="textbox"
                    :rules="requeridoRegla" v-mask="'#########'" />
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="8">
                <v-text-field label="Página Web *" color="textbox" v-model="obModal.paginaWeb" outlined dense
                    :rules="requeridoRegla" />
            </v-col>
            <v-col cols="12" sm="4">
                <v-autocomplete label="Estado *" color="textbox" v-model="obModal.idEstado" item-value="id_estado"
                    item-text="nombre_estado" :items="_.filter(listGeneral.listEstado,{'visualiza':'true'})" outlined
                    dense :rules="requeridoRegla" />
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="12">
                <h3 class="subtitle-1 font-weight-bold">Datos del Representante Legal</h3>
            </v-col>
        </v-row>

       <v-row dense>
            <v-col cols="12" sm="4">
                <v-text-field label="Cedula|RUC *" color="textbox" v-model="obModal.representanteLegalDocumento" outlined dense
                    :rules="tipoDocumento" />
            </v-col>
            <v-col cols="12" sm="8">
                <v-text-field label="Nombres *" v-model="obModal.representanteLegalNombre" outlined dense color="textbox"
                    :rules="_.concat(requeridoRegla,letrasRegla)" />
            </v-col>
        </v-row>

        <v-row dense>
            <v-col class="text-right">
                <v-btn outlined rounded class="mr-1" @click="onClose">Cancelar</v-btn>
                <v-btn rounded dark color="primary" @click="validar(2)">Guardar</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { mask } from 'vue-the-mask';
    export default {
        name: 'ModalClienteJuridicaComponent',
        inject: ['onClose', 'validar'],
        directives: {
            mask
        },
        props: {
            obModal: {
                type: Object,
                default: {}
            },
            listGeneral: {
                type: Object,
                default: {}
            },
            parametros: {
                type: Object,
                default: {}
            },
        },
        computed:{
            tipoDocumento(){
                var x = _.get(this.obModal,'nroDocumentoRL','');
                var rule = x.length == 0 || x.length < 11 ? this.cedula : this.ruc;
                return _.concat(this.requeridoRegla,rule);
            }
        },
        methods: {
            onListarCanton(event) {
                if (!_.isUndefined(event)) {
                    var error = 'E';
                    var o = {
                        opcion:'L',
                        idProvincia: this.obModal.idProvincia,
                        idEstado: this.parametros.id_estado_default
                    }

                    this.listGeneral.listCantonJur = [];
                    axios.post(`${BASE_URI}administrador/canton/listar`,o)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                this.$set(this.listGeneral,'listCantonJur',r.data.data);
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            }
        },
        mounted(){
            if(_.size(this.obModal.idCliente) > 0)
                this.onListarCanton('L')
        }
    }
</script>